import scriptDraftsService from './ScriptDraftService';
import isLocalStorageAvailable from './mini/isLocalStorageAvailable';
import { getCookie, setCookie } from './mini/cookie';
import { IProject } from '../models/IProject';
import { Environment } from '../const/environment';
import { ITransform } from '../models/ITransform';
import { removeEmptyRowsFromTransform } from '../views/pages/project/TransformMode/getTransformText';

const getProjectStorageKey = (projectId: string): string => {
    return `alan-${projectId}-environment`;
};

const projectHelper = {
    isLastTag: (project: IProject, tagId: string) => {
        let isLast = false;

        if (project && project.tags) {
            for (var i = 0; i < project.tags.length; i++) {
                const curTag = project.tags[i];
                if (curTag.tagId === tagId) {
                    if (curTag.message === 'last') {
                        isLast = true;
                        break;
                    }
                }
            }
        }

        return isLast;
    },
    getTagName: (project: IProject, environment: Environment) => {
        let tagName = '';
        for (var i = 0; i < project.tags.length; i++) {
            const curTag = project.tags[i];
            if (curTag.tagId === project[environment + 'TagId']) {
                tagName = curTag.message;
                break;
            }
        }
        return tagName;
    },


    getFilesWithUnsavedChanges: async (project: IProject) => {
        let unsavedFiles = {};
        if (project && project.scripts) {
            for (var i = 0; i < project.scripts.length; i++) {
                const script = project.scripts[i];
                const scriptDraft = await scriptDraftsService.getScriptText(script);
                if (script.type === 'transform') {
                    try {
                        const scriptDraftTransform: ITransform = JSON.parse(scriptDraft);
                        const scriptTextTransform: ITransform = JSON.parse(script.text);
                        const scriptDraftRemoved = removeEmptyRowsFromTransform(scriptDraftTransform);
                        const scriptTextRemoved = removeEmptyRowsFromTransform(scriptTextTransform);
                        const scriptDraftUnformatted = JSON.stringify(scriptDraftRemoved);
                        const scriptTextUnformatted = JSON.stringify(scriptTextRemoved);
                        if (scriptDraftUnformatted !== scriptTextUnformatted) {
                            unsavedFiles[script.name] = true;
                        }
                    } catch (error) {
                        console.error("Invalid transform format.");
                    }
                } else if (script.text !== scriptDraft) {
                    unsavedFiles[script.name] = true;
                    break;
                }
            }
        }
        return unsavedFiles;
    },

    hasUnsavedChanges: async (project: IProject) => {
        let hasUnsavedChanges = false;
        if (project && project.scripts) {
            for (var i = 0; i < project.scripts.length; i++) {
                const script = project.scripts[i];
                const scriptDraft = await scriptDraftsService.getScriptText(script);
                if (script.type === 'transform') {
                    try {
                        const scriptDraftTransform: ITransform = JSON.parse(scriptDraft);
                        const scriptTextTransform: ITransform = JSON.parse(script.text);
                        const scriptDraftRemoved = removeEmptyRowsFromTransform(scriptDraftTransform);
                        const scriptTextRemoved = removeEmptyRowsFromTransform(scriptTextTransform);
                        const scriptDraftUnformatted = JSON.stringify(scriptDraftRemoved);
                        const scriptTextUnformatted = JSON.stringify(scriptTextRemoved);
                        if (scriptDraftUnformatted !== scriptTextUnformatted) {
                            hasUnsavedChanges = true;
                            break;
                        }
                    } catch (error) {
                        console.error("Invalid transform format.");
                    }
                } else if (script.text !== scriptDraft) {
                    hasUnsavedChanges = true;
                    break;
                }
            }
        }
        return hasUnsavedChanges;
    },

    getEnvironment: (projectId: string): Environment => {
        const keyName = getProjectStorageKey(projectId);
        if (isLocalStorageAvailable() && projectId) {
            if (isLocalStorageAvailable() && projectId) {
                const storageVal = localStorage.getItem(keyName) as Environment;
                if (storageVal) {
                    return storageVal;
                }
            }
        } else {
            return getCookie(keyName) || Environment.Staging;
        }
        return Environment.Staging;
    },

    rememberProjectEnvironment: (projectId: string, environment: Environment) => {
        const keyName = getProjectStorageKey(projectId);
        if (isLocalStorageAvailable()) {
            localStorage.setItem(keyName, environment);
        } else {
            setCookie(keyName, environment, 10000);
        }
    },
    isSlu4_2: (project: IProject) => {
        return project?.sluVersion === '4-2';
    },
    isSlu4_1: (project: IProject) => {
        return project?.sluVersion === '4-1';
    }
};

export default projectHelper;